<template>
  <div>
    <div class="modal fade" id="freePackages" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title ml-4 float-left font-weight-bold">Free Packages</h5>
            <div class="select-all mt-1 position-relative">
              <input
                type="checkbox"
                class="bgc-checkbox checkbox-position position-relative"
                id="check20"
              >
              <label class="form-check-label" for="check20">
                <span class="pl-3">Select All</span>
              </label>
            </div>
            <button id="free_pack1_modal_renew" type="button" class="close" data-dismiss="modal">&times;</button>
          </div>
          <div class="ml-3 mr-4">
            <div class="style-border mt-1"/>
          </div>
          <div class="modal-body mt-1 pb-0">
            <div class="row mr-0">
              <div class="d-flex mt-3 mb-1 col-lg-12 col-md-12 col-sm-12 p-0">
                <div class="col-lg-6 col-md-6 col-sm-6 p-0">
                  <input
                    type="checkbox"
                    class="bgc-checkbox checkbox-position position-relative"
                    id="check2"
                  >
                  <label class="form-check-label" for="check2">
                    <span class="pl-3">Protector</span>
                  </label>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 p-0">
                  <input
                    type="checkbox"
                    class="bgc-checkbox checkbox-position position-relative"
                    id="check21"
                  >
                  <label class="form-check-label" for="check21">
                    <span class="pl-3">Personal Baggage</span>
                  </label>
                </div>
              </div>
              <div class="d-flex mt-3 mb-1 col-lg-12 col-md-12 col-sm-12 p-0">
                <div class="col-lg-6 col-md-6 col-sm-6 p-0">
                  <div class="bg-color py-3 mr-4">
                    <input
                      type="checkbox"
                      class="bgc-checkbox checkbox-position position-relative"
                      id="check22"
                    >
                    <label class="form-check-label" for="check22">
                      <span class="pl-3">Consumables</span>
                    </label>
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 p-0">
                  <div class="bg-color py-3">
                    <input
                      type="checkbox"
                      class="bgc-checkbox checkbox-position position-relative"
                      id="check23"
                    >
                    <label class="form-check-label" for="check23">
                      <span class="pl-3">24x7 Road Side Assistance</span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="mt-3 mb-1 d-flex col-lg-12 col-md-12 col-sm-12 p-0">
                <div class="col-lg-6 col-md-6 col-sm-6 p-0">
                  <div>
                    <input
                      type="checkbox"
                      class="bgc-checkbox checkbox-position position-relative"
                      id="check24"
                    >
                    <label class="form-check-label" for="check24">
                      <span class="pl-3">Tier Safe Guard</span>
                    </label>
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 p-0">
                  <div>
                    <input
                      type="checkbox"
                      class="bgc-checkbox checkbox-position position-relative"
                      id="check25"
                    >
                    <label class="form-check-label" for="check25">
                      <span class="pl-3">Rim Safe Guard</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="ml-3 mr-4">
            <div class="style-border mt-1"/>
          </div>
          <div>
            <div class="modal-footer border-0 float-right mr-3">
              <button id="add_free_pack_renew" type="button" class="btn bgc-btn-primary button-add" data-dismiss="modal">Add</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
 
<script>
export default {
  name: "FreePackagesModal",
};
</script>
<style scoped>
button.close {
  padding-top: 13px;
  text-align: right;
}
.button-add {
  width: 130px;
}
.checkbox-position {
  left: 15px;
}
.style-border {
  border-bottom: 1px solid #c7c7c7;
}
.bg-color {
  background-color: rgb(0, 0, 0, 0.05);
}
.select-all {
  left: calc(100% - 289px);
}
</style>